import {inject, Injectable, signal} from '@angular/core';
import {ChatTogetherAI} from '@langchain/community/chat_models/togetherai';
import {GoogleCustomSearch} from '@langchain/community/tools/google_custom_search';
import {MemoryVectorStore} from 'langchain/vectorstores/memory';
import {Document} from '@langchain/core/documents';
import {environment} from '@env/environments.llm-dev';
import {TogetherAIEmbeddings} from '@langchain/community/embeddings/togetherai';
import {Rag_search_web} from '@llm/dialogs/rag_search_web/rag_search_web';
import {llmStoreService} from '@llm/service/llm_store.service';
import { z } from "zod";
import { StructuredOutputParser } from "langchain/output_parsers";

import {Observable, of, switchMap} from "rxjs";
import {DataSelectComponent} from "@llm/dialogs/data-select/data-select.component";
import {MatDialog} from "@angular/material/dialog";
import {JsonExtractorService} from "@llm/service/json-extractor.service";
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

export type LlmResponseWebSearch = {
    markdownContent: string;
};
@Injectable({ providedIn: 'root' })
export class SearchWebInfoTool {

    private _dialog = inject(MatDialog);
    private _jsonExtractor = inject(JsonExtractorService)
    private _store= inject(llmStoreService)
    private _console = inject(Tools_aiConsoleService);
    public tools_call_search_web_markdown_info=signal<string | null>(null)

    // ⚠️ Claves expuestas (solo para pruebas)
    private GOOGLE_API_KEY = environment.SEARCH_GOOGLE_API_KEY;
    private GOOGLE_CSE_ID = environment.SEARCH_GOOGLE_CSE_ID;
    private TOGETHER_API_KEY = environment.TOGETHER_API_KEY_TEST;
    constructor() {}



    async search(query: string): Promise<string> {
        const parser = StructuredOutputParser.fromZodSchema(
            z.object({
                markdownContent: z.string().describe('Long extensive message in markdown structure(are rendered), with tables or other things you need for better understanding of the user')
            })
        );

        const formatInstructions = parser.getFormatInstructions();



        // 5. LLM con Together AI
        const llm = new ChatTogetherAI({
            apiKey: this.TOGETHER_API_KEY,
            model: environment.TOGETHER_MODEL_RASONING,
            temperature: 0,
            reasoning: { summary: 'detailed', effort: 'high' },
        });


        // 1. Búsqueda en Google
        const googleSearch = new GoogleCustomSearch({
            apiKey: this.GOOGLE_API_KEY,
            googleCSEId: this.GOOGLE_CSE_ID,
        });


        const searchResults = await googleSearch.call(query);
        //const filteredResults = searchResults.items.filter(item => item.snippet.length > 100);


        // 2. Crear documentos
        const docs = [new Document({ pageContent: JSON.stringify(searchResults) })];

        // 3. Embeddings con Together AI
        const embeddings = new TogetherAIEmbeddings({
            apiKey: this.TOGETHER_API_KEY,
            model: environment.TOGETHER_MODEL_EMBEDDING,
        });

        const vectorStore = await MemoryVectorStore.fromDocuments(docs, embeddings);

        // 4. Recuperar documentos relevantes
        const retriever = vectorStore.asRetriever();
        const retrievedDocs = await retriever.getRelevantDocuments(query);


        this._store.action_instant.update(() => 'Analisando dados obtidos')
        const response = await llm.invoke([
            [
                "system",
                "You are an assistant who responds in an objective, helpful, clear and proactive manner. Only respond in Brazilian Portuguese"
            ],
            [
                "human",
                `Based on this information, draft a detailed, well-structured and useful response for the user. 
                 #Important: to respond to the user after analyzing the provided information, you must return the information in the Long extensive message in markdown structure(are rendered), with tables or other things you need for better understanding of the user:
           
                 Información:
                 ${retrievedDocs.map(d => d.pageContent).join("\n\n")}`
            ]
        ]);
        const rawText = (response as any).content?.[0]?.text || (response as any).text;
        try {
            //const extractedJSONs = this._jsonExtractor.extractJSON(rawText);
            //const parsed: LlmResponseWebSearch = extractedJSONs[0];
            //console.log('parsed:', parsed)

            const markdownLimpio = limpiarMarkdown(rawText);

            //console.log("Mensaje corto:", parsed.markdownContent);
            //console.log("Mensaje largo:", markdownLimpio);

            //this.openRag_search_webDialog({ markdownText: markdownLimpio });
            this.tools_call_search_web_markdown_info.update(()=>markdownLimpio)
            return rawText;
        } catch (error) {
           this._console.error("No se pudo parsear la respuesta como JSON:", error);
           this._console.log("Texto recibido:", rawText);
            response.content =response.content + 'FeedBack_For_Assistant: Respond in a detailed summary manner without tables and conclude each answer with a suggestion to expand, improve, or explore the topic discussed'

            return response.content as string + '';
        }



        //return response.content as string;
    }



    /**
     * Abre un diálogo para que el usuario seleccione un dato de una lista.
     * Utilizado cuando una búsqueda de datos devuelve múltiples resultados.
     * @param _data Array de objetos any para mostrar en el diálogo.
     * @returns Un Observable que emite el ID del dato seleccionado o el ID del dato por defecto.
     */
    openRag_search_webDialog(_data: { markdownText: string }): Observable<string> {
        const dialogRef = this._dialog.open(Rag_search_web, {
            width: '600px',
            data: _data
        });

        return dialogRef.afterClosed().pipe(
            switchMap(result => result ? of(result.toString()) : of('defaultItem'))
        );
    }


    private limpiarMarkdown(entrada: string): string {
        return entrada
            // Convierte "\\n" en saltos de línea reales
            .replace(/\\n/g, '\n')
            // Elimina escapes innecesarios antes de caracteres como "|"
            .replace(/\\\|/g, '|')
            // Opcional: elimina espacios extra al inicio de cada línea
            .split('\n')
            .map(linea => linea.trimEnd())
            .join('\n');
    }

}
function limpiarMarkdown(entrada: string): string {
    return entrada
        // Convierte "\\n" en saltos de línea reales
        .replace(/\\n/g, '\n')
        // Elimina escapes innecesarios antes de caracteres como "|"
        .replace(/\\\|/g, '|')
        // Opcional: elimina espacios extra al inicio de cada línea
        .split('\n')
        .map(linea => linea.trimEnd())
        .join('\n');
}

